<template>
  <v-dialog v-model="componentLocalDialog" max-width="500px">
    <v-card>
      <v-card-title>
        <!--        <span class="headline">{{ $t("global.newItem") }}</span>-->
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :label="$t('global.name')"
                  :rules="[v => (v != null && v.length > 0) || $t('global.error.required')]"
                  v-model="componentLocalModel.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field :label="$t('global.defaultValue')" v-model="componentLocalModel.default_value"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-checkbox :label="$t('global.isRequired')" v-model="componentLocalModel.is_required"></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="close" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
        <v-btn :disabled="$store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>
          {{ componentLocalModel.id === null ? $t("global.add") : $t("global.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TravelServiceAdditionalParametersDialog",
  props: {
    dialog: { required: false, default: false },
    model: { required: false, default: null }
  },
  data: () => ({
    componentLocalModel: {
      id: null,
      name: "",
      is_required: false,
      default_value: ""
    }
  }),
  watch: {
    model(val) {
      if (typeof val !== "undefined" && val != null) {
        let tmp = JSON.parse(JSON.stringify(val));
        this.componentLocalModel.id = tmp.id;
        this.componentLocalModel.name = tmp.name;
        this.componentLocalModel.is_required = tmp.is_required;
        this.componentLocalModel.default_value = tmp.default_value;
      }
    }
  },
  computed: {
    componentLocalDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("update:dialog", value);
      }
    }
  },
  methods: {
    cleanComponentLocalModel() {
      this.componentLocalModel.id = null;
      this.componentLocalModel.name = "";
      this.componentLocalModel.is_required = false;
      this.componentLocalModel.default_value = "";
      this.$refs.form.resetValidation();
    },
    save() {
      this.axios
        .post("/settings/travel-service/save-additional-parameters", {
          additional_parameter: this.componentLocalModel
        })
        .then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
          this.$emit("saved");
          this.close();
          this.cleanComponentLocalModel();
        })
        .catch(() => {
          //TODO OBSLUGA BLEDOW
        });
    },
    close() {
      this.$emit("update:dialog", false);
      this.cleanComponentLocalModel();
    }
  }
};
</script>

<style scoped></style>
